import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@reactive-resume/ui";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { CreateProviderDto, PaymentProvider } from "@reactive-resume/dto";
import { useUpdateProvider } from "@/client/services/payment-provider/update-provider";
import { useDialog } from "@/client/stores/dialog";
import { useEffect } from "react";

export const EditPaymentProviderDialog = () => {
  const { isOpen, close, payload, mode } = useDialog<PaymentProvider>("edit-provider");
  const form = useForm<CreateProviderDto>({
    defaultValues: { name: payload?.item?.name },
  });
  const updateProvider = useUpdateProvider();

  const onSubmit = (data: CreateProviderDto) => {
    if (payload?.item) {
      updateProvider.mutate(
        { id: payload.item.id, name: data.name },
        {
          onSuccess: () => {
            form.reset();
            close();
          },
        },
      );
    }
  };
  useEffect(() => {
    if (payload) {
      form.reset({
        name: payload.item?.name,
      });
    }
  }, [payload]);

  if (mode !== "update") return null;
  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Éditer Fournisseur</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormField
              control={form.control}
              name="name"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Nom</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <DialogFooter>
              <Button type="submit">Mettre à jour</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
